// Shows the one-shot "you were moved to another workspace" notice (see
// lib/workspace-notice.ts) until dismissed.

import { useState } from 'react'
import { takeWorkspaceNotice } from '../lib/workspace-notice'

export function WorkspaceNoticeBanner() {
  const [message, setMessage] = useState<string | null>(() => takeWorkspaceNotice())
  if (!message) return null
  return (
    <div
      role="status"
      className="fixed inset-x-4 top-4 z-50 mx-auto flex max-w-xl items-start gap-3 rounded-[10px] border border-info/30 bg-info-soft px-4 py-3 text-base text-ink shadow-overlay"
    >
      <span className="flex-1">{message}</span>
      <button type="button" className="text-ink-2 hover:text-ink" aria-label="Dismiss" onClick={() => setMessage(null)}>
        ×
      </button>
    </div>
  )
}
